﻿<template>
  <div v-show="visible" class="iam-login-modal" @click.self="handleClose">
    <div class="iam-login-modal__panel">
      <button
        type="button"
        class="iam-login-modal__close"
        aria-label="关闭登录弹窗"
        @click="handleClose"
      >
        <i class="el-icon-close"></i>
      </button>
      <div class="iam-login-modal__body">
        <iframe
          v-show="loginUrl"
          ref="loginFrame"
          :src="loginUrl"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
        <div v-show="!loginUrl" class="iam-login-modal__loading">
          <i class="el-icon-loading"></i>
          <span>{{ loadingText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
  name: "IamLoginModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  created() {
    var self = this;
    this._boundAuthLoginMessage = function(e) { self.handleAuthLoginMessage(e); };
  },
  data() {
    return {
      loginUrl: "",
      loadingText: "正在加载登录页面...",
      tokenEventSource: null,
      tokenStreamAbortController: null,
      currentState: "",
      tokenSubscriptionStarted: false,
      loginFrameOrigin: ""
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (!this.loginUrl) {
          this.initLogin();
        } else {
          window.addEventListener("message", this._boundAuthLoginMessage);
        }
      }
    }
  },
  mounted() {

    // ====== 跨站 SSO：检查 URL 是否带 crossKey ======
    var self = this;
    var crossKey = this.getUrlParam("crossKey");
    if (crossKey) {
      // 立即清掉 URL crossKey 参数（同时更新 Vue Router 内部状态）
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete("crossKey");
        if (this.$router) {
          var q = {};
          u.searchParams.forEach(function(v, k) { q[k] = v; });
          this.$router.replace({ path: window.location.pathname, query: q });
        } else {
          window.history.replaceState({}, "", u.toString());
        }
      } catch (e) {};
      // 已登录则跳过
      try {
        var existingToken = localStorage.getItem("token");
        if (existingToken) { return; }
      } catch (e) {}

      api.crossKeyGet(crossKey)
        .then(async function(data) {
          var value = data && (data.value || data.data);
          if (!value) { self.preloadLogin(); return; }
          var payload;
          try { payload = JSON.parse(value); } catch (e) { payload = value; }
          var token = payload && (payload.token || payload.value);
          var source = payload && payload.source;
          if (!token) { self.preloadLogin(); return; }

          // auto-login
          if (source === "health") {
            var result = await self.exchangeDfbitToken(token);
            if (!result || !result.success) {
              self.preloadLogin();
              return;
            }
          } else {
            await self.handleTokenReceived({ token: token });
          }
          self.clearCrossKeyUrl();
        })
        .catch(function(err) {
          self.preloadLogin();
        });
      return;
    }

    this.preloadLogin();
    // 永久监听 iam-login-submit（QQ登录从新窗口回调，不依赖 visible）
    window.addEventListener("message", this._boundAuthLoginMessage);
  },
  beforeDestroy() {
    window.removeEventListener("message", this._boundAuthLoginMessage);
    this.teardownTokenSubscription();
  },
  methods: {
    handleClose() {
      this.teardownTokenSubscription();
      this.$emit("close");
    },
    resetState() {
      this.teardownTokenSubscription();
      this.loginUrl = "";
      this.currentState = "";
      this.tokenSubscriptionStarted = false;
      this.loadingText = "正在加载登录页面...";
      this.loginFrameOrigin = "";
    },
    // ====== 预加载登录 iframe（页面加载后立即执行，隐藏 iframe）======
    preloadLogin() {
      if (this.loginUrl) { return; }
      api.getSsoLoginUrl().then(res => {
        if (res && (res.code === 200 || res.error === 0) && res.data) {
          this.loginUrl = this.buildLoginUrl(res.data);
          this.loginFrameOrigin = new URL(this.loginUrl).origin;
          this.currentState = res.data.state || "";
          this.$nextTick(() => {
            if (this.$refs.loginFrame) {
              window.__bridgeFrame = this.$refs.loginFrame;
            }
          });
        } else {
        }
      }).catch(err => {
      });
    },
    // ====== 接收 iframe 发来的 iam-login-submit 信号（QQ登录从新窗口回调）======
    handleAuthLoginMessage(event) {
      var loginFrameWindow =
        this.$refs &&
        this.$refs.loginFrame &&
        this.$refs.loginFrame.contentWindow
          ? this.$refs.loginFrame.contentWindow
          : null;

      if (
        !event ||
        !event.data ||
        event.data.action !== "iam-login-submit"
      ) {
        return;
      }
      // QQ登录是弹出新窗口，回调页发给 opener（iframe）→ iframe 转发给父页面
      // 即使 modal 不可见（预加载模式），也要处理
      if (this.tokenSubscriptionStarted || !this.currentState) {
        return;
      }
      this.tokenSubscriptionStarted = true;
      this.subscribeToken(this.currentState);
    },

    // ====== 跨站 SSO crossKey ======
    generateCrossKey(token) {
      var raw = (token || "").replace(/^Bearer\s+/i, "");
      var prefix = raw.slice(0, 16);
      var encoded = btoa(prefix + ":" + Date.now()).replace(/=/g, "");
      var key = encoded.slice(0, 40);
      return key;
    },
    crossKeySave(key, value) {
      return api.crossKeySave(key, value).then(function(json) {
        return json;
      });
    },
    crossKeyDelete(key) {
      return api.crossKeyDelete(key).then(function(json) {
        return json;
      });
    },
    generateCrossKeyAndSave(token, userInfo) {
      var normalizedToken = (token || "").trim().replace(/^Bearer\s+/i, "");
      if (!normalizedToken) { return; }
      var crossKey = this.generateCrossKey(normalizedToken);
      var oldKey = localStorage.getItem("crossKey");
      var self = this;
      var p = Promise.resolve();
      var payload = { token: normalizedToken, source: "db" };
      if (userInfo) {
        payload.userInfo = {
          userName: userInfo.userName || "",
          phonenumber: userInfo.phonenumber || userInfo.phone || "",
          userId: userInfo.userId || ""
        };
      }
      if (oldKey && oldKey !== crossKey) {
        p = this.crossKeyDelete(oldKey).catch(function(err) {
        });
      }
      return p.then(function() {
        return self.crossKeySave(crossKey, JSON.stringify(payload));
      }).then(function(res) {
        localStorage.setItem("crossKey", crossKey);
        return res;
      }).catch(function(err) {
      });
    },

    // ====== 工具函数 ======
    clearCrossKeyUrl() {
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete("crossKey");
        if (this.$router) {
          var q = {};
          u.searchParams.forEach(function(v, k) { q[k] = v; });
          this.$router.replace({ path: window.location.pathname, query: q });
        } else {
          window.history.replaceState({}, "", u.toString());
        }
      } catch (e) {}
    },
    getUrlParam(name) {
      var m = window.location.search.match(new RegExp("[?&]" + name + "=([^&]*)"));
      return m ? decodeURIComponent(m[1]) : null;
    },
    getRuntimeConfig() {
      if (typeof cfg !== "undefined") {
        return cfg;
      }
      return {};
    },
    resolveAuthLoginOrigin() {
      var runtimeConfig = this.getRuntimeConfig();
      if (runtimeConfig.authLoginOrigin) {
        return runtimeConfig.authLoginOrigin.replace(/\/$/, "");
      }
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        return "http://127.0.0.1:3321";
      }
      return "http://www.healthoo.com";
    },
    resolveBridgeEnv() {
      var runtimeConfig = this.getRuntimeConfig();
      var authLoginOrigin = runtimeConfig.authLoginOrigin || "";
      var healthSiteOrigin = runtimeConfig.healthSiteOrigin || "";
      var envSource =
        window.location.hostname + " " + authLoginOrigin + " " + healthSiteOrigin;
      var env = "test";
      if (
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1"
      ) {
        env = "local";
      } else if (/member\.healthoo\.com|www\.healthoo\.com|(^|\.)healthoo\.net/i.test(envSource)) {
        env = "prod";
      }
      return env;
    },
    normalizeExchangeToken(token) {
      if (!token || typeof token !== "string") {
        return "";
      }
      return token.trim().replace(/^Bearer\s+/i, "");
    },

    // ====== 快捷登录：用 iframe 传来的 token 调后端交换 ======
    async exchangeDfbitToken(thirdToken) {
      var normalizedToken = this.normalizeExchangeToken(thirdToken);
      if (!normalizedToken) {
        return {
          success: false,
          reason: "expired"
        };
      }
      try {
        var res = await api.exchangeDbSiteToken({
          thirdType: "dfbit",
          clientType: "WEB",
          thirdToken: normalizedToken
        });
        var success =
          !!res && (res.code === 200 || res.error === 0) && (res.token || res.data);
        if (!success) {
          var code = Number(res && (res.code || res.error || res.errorCode));
          var message = (res && (res.msg || res.message)) || "";
          var reason = message.indexOf("三方用户信息获取异常") > -1 ? "invalid" : (code >= 500 ? "server" : "invalid");
          return {
            success: false,
            reason: reason
          };
        }
        await this.handleTokenReceived({
          token: res.token || res.data,
          sign: res.sign || ""
        });
        return {
          success: true,
          reason: ""
        };
      } catch (error) {
        return {
          success: false,
          reason: "network"
        };
      }
    },
    // ====== 构建登录 iframe URL ======
    buildLoginUrl(data) {
      var runtimeConfig = this.getRuntimeConfig();
      var authLoginBaseUrl = this.resolveAuthLoginOrigin() + "/authLogin/";

      if (!runtimeConfig.forceLocalAuthLogin && data.loginPageUrl) {
        authLoginBaseUrl = data.loginPageUrl;
      }

      var authUrlObj = new URL(authLoginBaseUrl);
      if (data.authUrl) {
        authUrlObj.searchParams.append("authUrl", data.authUrl);
      }
      if (data.clientId) {
        authUrlObj.searchParams.append("clientId", data.clientId);
      }
      if (data.callbackUrl) {
        authUrlObj.searchParams.append("callbackUrl", data.callbackUrl);
      }
      if (data.state) {
        authUrlObj.searchParams.append("state", data.state);
      }
      authUrlObj.searchParams.append("response_type", "code");
      authUrlObj.searchParams.append("source", "db");
      authUrlObj.searchParams.append("parentOrigin", window.location.origin);
      authUrlObj.searchParams.append("bridgeEnv", this.resolveBridgeEnv());
      // 跨站 SSO：传递 crossKey 给 iframe
      var crossKey = localStorage.getItem("crossKey");
      if (crossKey) {
        authUrlObj.searchParams.append("crossKey", crossKey);
      } else {
      }
      authUrlObj.searchParams.append("_t", Date.now());
      var url = authUrlObj.toString();
      return url;
    },

    // ====== 初始化登录 ======
    async initLogin() {
      this.teardownTokenSubscription();
      this.loginUrl = "";
      this.currentState = "";
      this.tokenSubscriptionStarted = false;
      this.loadingText = "正在加载登录页面...";
      window.removeEventListener("message", this._boundAuthLoginMessage);
      window.addEventListener("message", this._boundAuthLoginMessage);

      this.loadingText = "正在加载登录页面...";
      api
        .getSsoLoginUrl()
        .then(res => {
          if (res && (res.code === 200 || res.error === 0) && res.data) {
            this.loginUrl = this.buildLoginUrl(res.data);
            this.loginFrameOrigin = new URL(this.loginUrl).origin;
            this.currentState = res.data.state || "";
            return;
          }
          this.$message.error((res && res.msg) || "获取登录链接失败");
          this.handleClose();
        })
        .catch(error => {
          this.$message.error(error || "获取登录链接失败");
          this.handleClose();
        });
    },
    subscribeToken(state) {
      if (!state) {
        return;
      }

      this.teardownTokenSubscription();
      this.tokenSubscriptionStarted = true;

      var runtimeConfig = this.getRuntimeConfig();
      var ssoSseUrl = runtimeConfig.ssoSseUrl || "";

      if (!ssoSseUrl || typeof fetch === "undefined") {
        return;
      }

      try {
        var eventUrl = new URL(ssoSseUrl, window.location.origin);
        eventUrl.searchParams.set("state", state);
        this.subscribeTokenByFetch(eventUrl.toString());
      } catch (error) {
        this.teardownTokenSubscription();
      }
    },
    subscribeTokenByFetch(url) {
      if (!url || typeof fetch === "undefined") {
        return;
      }

      this.tokenSubscriptionStarted = true;
      this.tokenStreamAbortController = new AbortController();

      fetch(url, {
        method: "GET",
        signal: this.tokenStreamAbortController.signal
      })
        .then(response => {
          if (!response || !response.body || !response.body.getReader) {
            return response.text().then(text => {
              this.handleFetchStreamText(text);
            });
          }

          var reader = response.body.getReader();
          var decoder = new TextDecoder("utf-8");
          var buffer = "";

          var pump = () => {
            return reader.read().then(result => {
              if (result.done) {
                this.handleFetchStreamText(buffer);
                return;
              }

              buffer += decoder.decode(result.value, { stream: true });

              if (this.tryHandleFetchStreamBuffer(buffer)) {
                return;
              }

              return pump();
            });
          };

          return pump();
        })
        .catch(() => {
          this.teardownTokenSubscription();
        });
    },
    tryHandleFetchStreamBuffer(buffer) {
      if (!buffer) {
        return false;
      }

      var normalizedBuffer = buffer;
      var dataIndex = normalizedBuffer.indexOf("data:");

      if (dataIndex > -1) {
        normalizedBuffer = normalizedBuffer.slice(dataIndex + 5);
      }

      var startIndex = normalizedBuffer.indexOf("{");
      var endIndex = normalizedBuffer.lastIndexOf("}");

      if (startIndex === -1 || endIndex <= startIndex) {
        return false;
      }

      var jsonText = normalizedBuffer.slice(startIndex, endIndex + 1).trim();

      try {
        var payload = JSON.parse(jsonText);
        if (
          payload &&
          (payload.token || payload.accessToken || payload.Authorization)
        ) {
          this.teardownTokenSubscription();
          this.handleTokenReceived(payload);
          return true;
        }
      } catch (error) {
        return false;
      }

      return false;
    },
    handleFetchStreamText(text) {
      if (!text) {
        this.teardownTokenSubscription();
        return;
      }

      if (!this.tryHandleFetchStreamBuffer(text)) {
        this.teardownTokenSubscription();
      }
    },
    teardownTokenSubscription() {
      if (this.tokenEventSource) {
        this.tokenEventSource.close();
        this.tokenEventSource = null;
      }
      if (this.tokenStreamAbortController) {
        this.tokenStreamAbortController.abort();
        this.tokenStreamAbortController = null;
      }
      this.tokenSubscriptionStarted = false;
    },
    // ====== 新增：等待登录 iframe 确认收到 token ======
    waitForLoginAck(timeout) {
      timeout = timeout || 1000;
      var self = this;
      return new Promise(function (resolve) {
        function handler(event) {
          if (event.data && event.data.action === "iam-login-acked") {
            window.removeEventListener("message", handler);
            clearTimeout(timer);
            resolve(true);
          }
        }
        var timer = setTimeout(function () {
          window.removeEventListener("message", handler);
          resolve(false);
        }, timeout);
        window.addEventListener("message", handler);
      }).then(function (result) {
        return result;
      });
    },
    // ====== waitForLoginAck 结束 ======

    async handleTokenReceived(tokenPayload) {
      var token = "";
      var sign = "";

      if (typeof tokenPayload === "string") {
        token = tokenPayload;
      } else if (tokenPayload && typeof tokenPayload === "object") {
        token =
          tokenPayload.token ||
          tokenPayload.accessToken ||
          tokenPayload.Authorization ||
          "";
        sign = tokenPayload.sign || "";
      }


      if (
        !token ||
        (typeof token === "string" &&
          (token === "{" || token === "}" || token.indexOf("{") > -1))
      ) {
        this.handleClose();
        return;
      }

      this.loadingText = "正在校验登录结果...";
      localStorage.setItem("token", token);
      localStorage.removeItem("dmiToken");
      if (sign) {
        localStorage.setItem("sign", sign);
      }

      this.loadingText = "正在获取用户信息...";
      var self = this;
      return api
        .getUserInfo()
        .then(async function (userInfo) {
          // 登录成功，关闭弹窗后重置信令重新预加载 iframe
          // ====== 新方式：直接把 token 传给登录 iframe ======
          // 旧方式（已废弃）：pushBridgeToken → 创建隐藏 iframe → postMessage
          // 新方式：当前登录 iframe 还开着，直接传给它，它存到 localStorage
          var loginFrameWindow = self.$refs.loginFrame && self.$refs.loginFrame.contentWindow;
          if (loginFrameWindow) {
            loginFrameWindow.postMessage({
              action: "iam-login-token",
              token: token,
              tokenKey: "sysdbToken",
              source: "db",
              sourceLabel: "数据库网",
              userName: userInfo.userName || "",
              phone: userInfo.phone || userInfo.phonenumber || "",
              userId: userInfo.userId || ""
            }, "*");

            // 等待 iframe 确认收到
            var ackResult = await self.waitForLoginAck(1000);
          } else {
          }

          // ====== 跨站 SSO：生成 crossKey 存入服务器 ======
          await self.generateCrossKeyAndSave(token, userInfo);

          self.loginUrl = "";

          self.$message.success("登录成功");
          self.$emit("success", userInfo);
          self.handleClose();
        })
        .catch(function (error) {
          self.$message.error(error || "获取用户信息失败");
          self.handleClose();
        })
        .finally(function () {
          self.preloadLogin();
        });
    }
  }
};
</script>

<style lang="less" scoped>
.iam-login-modal {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 3000;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(8, 31, 62, 0.42);
}

.iam-login-modal__panel {
  position: relative;
  width: 750px;
  max-width: calc(100vw - 48px);
  height: 430px;
  max-height: calc(100vh - 80px);
  overflow: visible;
  border-radius: 14px;
  background: transparent;
  box-shadow: 0 20px 55px rgba(13, 47, 87, 0.18);
}

.iam-login-modal__close {
  position: absolute;
  top: -18px;
  right: -18px;
  z-index: 3;
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(13, 47, 87, 0.24);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  cursor: pointer;
  outline: none;
  padding: 0;
}

.iam-login-modal__close:hover {
  background: #f5f9ff;
}

.iam-login-modal__close i {
  font-size: 18px;
  color: #35506f;
  font-weight: 700;
}

.iam-login-modal__body {
  height: 100%;
  border-radius: 14px;
  overflow: hidden;
  background: #ffffff;
}

.iam-login-modal__loading {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5e7188;
  font-size: 15px;
}

.iam-login-modal__loading i {
  margin-right: 10px;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/common/IamLoginModal.vue